export const config = {
  rowSelection: false,
  columns: [
    {
      title: 'SPU名称',
      dataIndex: 'specialCode',
      width: 350,
      name: 'specialCode',
      render: 'renderProduct',
    },
    {
      title: '产品类型',
      dataIndex: 'prodTypeName',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '需求标签',
      dataIndex: 'bizTagName',
      width: 120,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '打包模板',
      dataIndex: 'packModelName',
      name: 'packModelName',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '模板类型',
      dataIndex: 'packModelTypeName',
      name: 'packModelTypeName',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '关联商品',
      dataIndex: 'associatedGoodsNames',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '上架门店',
      dataIndex: 'associatedGoodsSkuShelvesShopNames',
      width: 300,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '产品分类',
      dataIndex: 'prodCateName',
      width: 140,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '品牌',
      dataIndex: 'brandName',
      width: 100,
      ellipsis: {
        showTitle: false,
      },
    },

    {
      title: '单位',
      dataIndex: ['unitInfo', 'unitName'],
      width: 80,
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: '特项代码',
      dataIndex: 'specialCode',
      name: 'specialCode',
      width: 100,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 180,
      itemType: 'dateTime',
    },
    {
      title: 'SPU状态',
      dataIndex: 'enabledName',
      name: 'enabledName',
      width: 100,
      fixed: 'right',
      render: 'enableRender',
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 100,
      fixed: 'right',
      render: 'actionRender'
    },
  ],
  search: [
    {
      label: 'SPU名称',
      name: 'nameKey',
    },
    {
      label: '产品SPU_ID',
      name: 'id',
    },
    {
      label: '需求标签',
      name: 'bizTag',
      itemType: 'select',
      data: 'demandList',
      key: 'value',
      labelKey: 'label',
    },
    {
      label: 'SPU状态',
      itemType: 'select',
      name: 'enabled',
      key: 'value',
      labelKey: 'label',
      data: [
        { label: '启用', value: true },
        { label: '禁用', value: false },
      ],
    },
    {
      label: '关联商品名称',
      name: 'associatedGoodsName',
    },
    {
      label: '上架门店',
      name: 'associatedGoodsSkuShelvesShopId',
      itemType: 'select',
      key: 'id',
      labelKey: 'companyName',
      data: 'companyList',
    },
  ],
  footer: false,
}
